import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router';

import { store } from 'state/store';
import { pushHistory } from 'state/journey-routes/journey-routes-slice';

type RedirectComponentProps = {
  path: string;
};

export const RedirectComponent = ({ path }: RedirectComponentProps) => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(pushHistory(path));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Navigate
      to={{ pathname: path, search: location.search }}
      state={{ store: store.getState() }}
      replace
    />
  );
};
